import { SparklesIcon } from '@heroicons/react/24/outline';
import React from 'react';

/**
 * Where a pre-ticked box doesn't count as consent to marketing email (EU/EEA, UK, Switzerland, Canada),
 * judged from the browser's time zone. Unknown counts as "ask first".
 */
const ASK_FIRST = /^(Europe\/|Atlantic\/(Reykjavik|Canary|Madeira|Azores|Faroe)|Arctic\/)|^America\/(Toronto|Vancouver|Montreal|Halifax|Winnipeg|Edmonton|Regina|St_Johns|Moncton|Glace_Bay|Goose_Bay|Whitehorse|Yellowknife|Iqaluit|Rankin_Inlet|Resolute|Cambridge_Bay|Inuvik|Dawson|Dawson_Creek|Fort_Nelson|Creston|Swift_Current|Atikokan|Blanc-Sablon|Nipigon|Thunder_Bay|Rainy_River|Pangnirtung)$/;

// #region defaultNewsConsent
/** Ticked to start with, except where the law needs the visitor to tick it themselves. */
export const defaultNewsConsent = (): boolean => {
    try {
        const zone = Intl.DateTimeFormat().resolvedOptions().timeZone ?? '';
        return !!zone && !ASK_FIRST.test(zone);
    } catch {
        return false;
    }
};

// #region NewsOptIn
/** The optional "keep me posted" box, shared by the booking page and the Get started form. */
export const NewsOptIn: React.FunctionComponent<{ checked: boolean; onChange: (on: boolean) => void }> = ({ checked, onChange }) => (
    <label className={`flex cursor-pointer items-start gap-3 rounded-xl border p-3 transition ${checked ? 'border-emerald-600/50 bg-emerald-600/5' : 'border-surface-border hover:border-zinc-400'}`}>
        <input type="checkbox" className="mt-1 h-4 w-4 shrink-0 rounded border-surface-border accent-emerald-600" checked={checked} onChange={(ev) => onChange(ev.target.checked)} />
        <span className="flex flex-col gap-0.5 text-sm">
            <span className="inline-flex items-center gap-1.5 font-medium text-zinc-900 dark:text-zinc-100">
                <SparklesIcon className="h-4 w-4 text-emerald-600" aria-hidden />
                Get first look at what&apos;s new
            </span>
            <span className="text-zinc-600 dark:text-zinc-400">New patterns and products, launch news and tips for selling wallpaper. Occasional emails, unsubscribe anytime.</span>
        </span>
    </label>
);
